export function getList(value) {
  return value.items.map(item => ({
    id: item.quickstart_id,
    text: item.monitoring_config.protocol_title,
  }))
}
